<!--
 * @Description: 
 * @Author: DOJO
 * @Date: 2020-04-01 18:17:54
 * @LastEditTime: 2020-04-03 17:32:17
 * @LastEditors: DOJO
 -->
<template>
<div class="item-message">
  <head-top v-if="appCont != 0"></head-top>
  <ul class="add-edit-address-ul border-bottom-1px gray-light">
    <li>
      <div class="border-bottom-1px gray-light address-input-box categoryId">
        <p class="title">商品分类</p>
        <div class="relative">
          <select placeholder="请选择" class="select" :class="{'l-h-1': isIphone}" @change="categorySelection(itemObj.categoryId)" v-model="itemObj.categoryId">
            <option v-for="(item, index) in itemList" :key="index" :value="item.value">{{item.label}}</option>
          </select>
          <span class="color-grey absolute-txt" v-if="!itemObj.categoryId">请选择</span>
        </div>
        <img src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/bottom_arrow.png" class="b-arrow" />
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box itemName">
        <p class="title">商品名称</p>
        <input class="fr" type="text" placeholder="请填写商品名称" maxlength="30" v-model.trim="itemObj.itemName">
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box block itemImg">
        <p class="title">商品图片</p>
        <div class="m-10">
          <div class="w-64" v-if="imgList.length" v-for="(item, index) in imgList" :key="index">
            <img :src="item" />
            <div class="handle-btn" @click="deleImgByIndex">X</div>
          </div>
          <div class="w-64" v-if="imgList.length < 5">
            <img v-if="upLoadingImg" src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/loading.png" class="loading" />
            <img src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/add.png" />
            <input type="file" class="file" multiple accept="image/jpg,image/png,image/jpeg" @change="fileChange">
          </div>
        </div>
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box block video">
        <p class="title">商品亮点介绍视频</p>
        <div class="m-10">
          <div class="w-64" v-if="videoList.length == 1" v-for="(item, index) in  videoList" :key="index">
            <img src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/defaultVideo.jpg" />
            <div class="handle-btn" @click="deleVideoByIndex">X</div>
            <img class="play-btn" src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/play.png" @click="playVideo" alt="" srcset="">
          </div>
          <div class="w-64" v-if="videoList.length < 1">
            <img v-if="upLoadingVideo" src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/loading.png" class="loading" />
            <img src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/add.png" />
            <input type="file" class="file" accept="video/mp4,video/mov,video/rmvb" @change="videoUpload">
          </div>
        </div>
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box vipPrice">
        <p class="title">市场参考价</p>
        <input class="fr color-3" type="number" @blur="handleNum(1, itemObj.vipPrice)" placeholder="请填写市场参考价" maxlength="20" v-model.trim="itemObj.vipPrice">
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box specPrice">
        <p class="title">建议云集售价</p>
        <input class="fr color-3" type="number" @blur="handleNum(2,itemObj.specPrice)" placeholder="请填写建议云集售价" maxlength="20" v-model.trim="itemObj.specPrice">
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box supplyCommodityPrice">
        <p class="title">云集供货价</p>
        <input class="fr color-3" type="number" @blur="handleNum(3, itemObj.supplyCommodityPrice)" placeholder="请填写云集供货价" maxlength="20" v-model.trim="itemObj.supplyCommodityPrice">
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box annualSales">
        <p class="title">年销售额（万）</p>
        <input class="fr color-3" type="number" @blur="handleNum(4, itemObj.annualSales)" placeholder="请填写年销售额（万）" maxlength="10" v-model.trim="itemObj.annualSales">
      </div>
    </li>
  </ul>
  <ul class="add-edit-address-ul border-bottom-1px gray-light">
    <li>
      <div class="border-bottom-1px gray-light address-input-box block recommendReason">
        <p class="title">推荐理由<span class="sub-title"></span></p>
        <div class="m-r-4">
          <textarea maxlength="1000" placeholder="商品功能，对标云集现有同类商品的优势，对标哪款主流品牌商品的优势" v-model="itemObj.recommendReason" class="textarea" cols="30" rows="10"></textarea>
        </div>
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box block salesNumImg">
        <p class="title">商品销量证明<span class="sub-title">（单品出货额不低于500万的证明）</span></p>
        <div class="m-10">
          <div class="w-64" v-if="salesNumImgList.length" v-for="(item, index) in salesNumImgList" :key="index">
            <img :src="item" />
            <div class="handle-btn" @click="deleSaleByIndex">X</div>
          </div>
          <div class="w-64" v-if="salesNumImgList.length < 5">
            <img v-if="upLoadingSaleImg" src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/loading.png" class="loading" />
            <img src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/add.png" />
            <input type="file" class="file" multiple accept="image/jpg,image/png,image/jpeg" @change="salesFileChange">
          </div>
        </div>
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box block qualityImg">
        <p class="title">商品品质证明<span class="sub-title">（线上，商品评价截图；线下，近6个月复购订单截图）</span></p>
        <div class="m-10">
          <div class="w-64" v-if="itemImgList.length" v-for="(item, index) in itemImgList" :key="index">
            <img :src="item" />
            <div class="handle-btn" @click="deleItemByIndex">X</div>
          </div>
          <div class="w-64" v-if="itemImgList.length < 5">
            <img v-if="upLoadingImg" src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/loading.png" class="loading" />
            <img src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/add.png" />
            <input type="file" class="file" multiple accept="image/jpg,image/png,image/jpeg" @change="itemfileChange">
          </div>
        </div>
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box block">
        <p class="title">口碑、体量证明对应平台链接<span class="sub-title">（线下销售无需提供）</span></p>
        <div class="m-r-4">
          <textarea maxlength="500" placeholder="填写口碑、体量证明对应平台链接" v-model="itemObj.platformLink" class="textarea h-68" cols="30" rows="10"></textarea>
        </div>
      </div>
    </li>
  </ul>
  <ul class="add-edit-address-ul border-bottom-1px gray-light">
    <li>
      <div class="border-bottom-1px gray-light address-input-box contactsName">
        <p class="title">联系人</p>
        <input class="fr" type="text" placeholder="请填写姓名" maxlength="15" v-model.trim="itemObj.contactsName">
        <div class="w-68">
          <select placeholder="请选择" class="select" :class="{'l-h-1': isIphone}" v-model="itemObj.contactsSex">
            <option value="0">先生</option>
            <option value="1">女士</option>
          </select>
          <img src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/bottom_arrow.png" class="b-arrow" />
        </div>
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box contactsPhone">
        <p class="title">联系电话</p>
        <input class="fr" @keyup="changePhone" type="tel" placeholder="请填写号码" maxlength="30" v-model.trim="itemObj.contactsPhone">
      </div>
    </li> 
    <li>
      <div class="border-bottom-1px gray-light address-input-box contactsEmail">
        <p class="title">联系邮箱</p>
        <input class="fr" type="text" placeholder="请填写邮箱" maxlength="200" v-model.trim="itemObj.contactsEmail">
      </div>
    </li>
  </ul>
  <ul class="add-edit-address-ul border-bottom-1px gray-light">
    <li>
      <div class="border-bottom-1px gray-light address-input-box companyName">
        <p class="title">公司名称</p>
        <input class="fr" type="text" placeholder="请填写公司名称" maxlength="50" v-model.trim="itemObj.companyName">
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box businessLife">
        <p class="title">营业年限</p>
        <input class="fr" type="tel" @blur="changeNum" placeholder="请填写营业年限" maxlength="20" v-model.trim="itemObj.businessLife"><span class="p-r-2">年</span>
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box companyType">
        <p class="title">公司类型</p>
        <div class="relative">
          <select placeholder="请选择" class="select" :class="{'l-h-1': isIphone}" v-model="itemObj.companyType" @change="changeCompany(itemObj.companyType)">
            <option v-for="(item, index) in companyList" :key="index" :value="item.value">{{item.label}}</option>
          </select>
          <img src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/bottom_arrow.png" class="b-arrow" />
          <span class="color-grey absolute-txt" v-if="!itemObj.companyType">请选择</span>
        </div>
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box cooperativeBrand block">
        <p class="title">知名合作品牌</p>
        <div class="m-r-4">
          <textarea maxlength="100" placeholder="商品所在类目下，至少一个知名品牌的长期代工经验" v-model="itemObj.cooperativeBrand" class="textarea" cols="30" rows="10"></textarea>
        </div>
      </div>
    </li>
    <li>
      <div class="border-bottom-1px gray-light address-input-box infoChannel">
        <p class="title">信息获取渠道</p>
        <div class="relative">
          <select placeholder="请选择" class="select" :class="{'l-h-1': isIphone}" @change="changeChannel(itemObj.infoChannel)" v-model="itemObj.infoChannel">
            <option v-for="(item, index) in infoChannelList" :key="index" :value="item.value">{{item.label}}</option>
          </select>
          <img src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/bottom_arrow.png" class="b-arrow" />
          <span class="color-grey absolute-txt" v-if="!itemObj.infoChannel">请选择</span>
        </div>
      </div>
    </li>
  </ul>
  <div class="next-btn" @click="validParam">提交</div>
  <VideoModel ref="videoHook" v-if="videoList.length" :video="video"></VideoModel>
  <div class="save-loading" v-if="saveLoading">
    <vLoad />
  </div>
  <div class="tip-dialog" v-if="tipStatus">
    <div class="dialog-txt">
      <div class="tip-txt">
        <div v-if="errorStatus == 'error'">
          <div>您提交的信息不完整</div>
          <div>请补充信息后提交</div>
        </div>
        <div v-if="errorStatus == 'submit'">
          <div>恭喜，爆款商品信息提交成功</div>
          <!-- <div>5s后返回上一页</div> -->
        </div>
      </div>
      <div class="handle-box" @click="handleDialog">
        <div>我知道了</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import YunJi from '@/common/js/YunJi.js'
import headTop from './header.vue'
import VideoModel from './VideoModel'
import vLoad from './loading'


export default {
  data() {
    return {
      tipNum: 5,
      isIphone: YunJi.getPhoneType(),
      tipStatus: false,
      errorStatus: false,
      saveLoading: false,
      appCont: YunJi.getUrlParams('appCont') || 0, // 客户端标识 0-H5，1-卖家版，2-买家版
      shopId: YunJi.getUrlParams('shopId'),
      salesNumImgList: [],
      video: {
        src: '',
        visible: false
      },
      upLoadingVideo: false,
      upLoadingImg: false,
      upLoadingSaleImg: false,
      videoList: [],
      itemImgList: [],
      maxVideoSize: 1,
      maxImageSize: 5,
      maxVideoSizeM: 10, //  视频大小10M
      imgList: [],
      token: '',
      tipTxt: '您提交的信息不完整，请补充信息后提交',
      itemList: [{
        label: '家居生活',
        value: 1
      }, {
        label: '本地生活/旅游出行',
        value: 2
      }, {
        label: '运动户外',
        value: 3
      }, {
        label: '家用电器',
        value: 4
      }, {
        label: '家庭清洁/纸品',
        value: 5
      }, {
        label: '美妆护肤',
        value: 6
      }, {
        label: '手机数码',
        value: 7
      }, {
        label: '礼品配饰',
        value: 8
      }, {
        label: '服饰内衣',
        value: 9
      }, {
        label: '鞋靴箱包',
        value: 10
      }, {
        label: '宠物生活',
        value: 11
      }, {
        label: '图书',
        value: 12
      }, {
        label: '酒类',
        value: 13
      }, {
        label: '健康电器',
        value: 14
      }, {
        label: '家具家装',
        value: 15
      }, {
        label: '个人护理',
        value: 16
      }, {
        label: '家纺',
        value: 17
      }, {
        label: '生鲜',
        value: 18
      }, {
        label: '医疗保健',
        value: 19
      }, {
        label: '食品饮料',
        value: 20
      }, {
        label: '母婴玩具',
        value: 21
      }, {
        label: '电脑办公/汽车用品',
        value: 22
      }],
      companyList: [{
        label: '工厂',
        value: 1
      }, {
        label: '品牌方',
        value: 2
      }, {
        label: '经销商',
        value: 3
      }, {
        label: '个体工商户',
        value: 4
      }],
      infoChannelList: [{
        label: '微信朋友圈',
        value: 1
      }, {
        label: '朋友推荐',
        value: 2
      }, {
        label: '云集工作人员提供',
        value: 3
      }, {
        label: '其他',
        value: 4
      }],
      itemObj: {
        businessLife: '', // 营业年限
        categoryId: '', // 分类id
        categoryName: '', // 分类名称
        // checkImg: '', // 审核截图，多张以英文分号分隔
        // checkStatus: '', // 审核状态，0-待审核，1-通过，2-不通过
        companyName: '', // 公司名称
        companyType: '', // 公司类型
        companyTypeName: '', // 公司类型名称
        contactsEmail: '', // 联系人邮箱
        contactsName: '', // 联系人姓名
        contactsPhone: '', // 联系人电话
        contactsSex: 0, // 联系人性别，0-男性，1-女性
        cooperativeBrand: '', // 知名合作品牌
        itemImg: '', // 商品图片，多张以英文分号分隔
        itemName: '', // 商品名称
        qualityImg: '', // 商品品质证明，多张以英文分号分隔
        recommendReason: '', // 推荐理由
        // similarItemLink: '', // 同类同款商品链接，多条以英文分号分隔
        specPrice: '', // 建议云集售价
        supplyCommodityPrice: '', // 云集供货价
        annualSales: '', // 年销售额
        vipPrice: '', // 市场参考价,
        video: '', // 亮点介绍视频，多个以英文分号分隔,
        salesNumImg: '', // 销量证明图片，多张以英文分号分隔,
        platformLink: '', // 口碑体量证明对应平台链接，多条以英文分号分隔
        infoChannel: '', // 信息获取渠道id
        infoChannelName: '' // 信息获取渠道
      }
    }
  },
  mounted() {
    document.documentElement.scrollTop = document.body.scrollTop = 0
    this.initParams()
    this.getTokens()
  },
  components: {
    headTop,
    VideoModel,
    vLoad
  },
  computed: {
  },
  methods: {
    handleDialog() {
      this.tipStatus = false
    },
    changePhone() {
      this.itemObj.contactsPhone = this.itemObj.contactsPhone.replace(/[^\d]/g, '')
    },
    changeNum() {
      if (!parseInt(this.itemObj.businessLife, 10)) {
        this.Toast('请输入正整数')
        this.itemObj.businessLife = ''
        return 
      }
      this.itemObj.businessLife = Math.floor(this.itemObj.businessLife) || 0
    },
    handleNum(type, value) {
      const val = parseFloat(value)
      const valPrice = Math.floor(val * 100) / 100
      const typeObj = {
        1: '市场参考价请输入0-999999之间',
        2: '建议云集售价请输入0-999999之间',
        3: '云集供货价请输入0-999999之间',
        4: '请填写年销售额（万）'
      }
      
      if (val && type === 4 && (val.toString().length > 9 || !parseInt(val, 10))) {
        this.Toast('请填写正确的年销售额')
        return 
      }
      if (!val || val <= 0 || (type !== 4 && val >= 999999)) {
        this.Toast(typeObj[type])
        return 
      }
      if (type == 1 && val) {
        this.itemObj.vipPrice = valPrice
      } else if (type == 2 && val) {
        this.itemObj.specPrice = valPrice
      } else if (type == 3 && val) {
        this.itemObj.supplyCommodityPrice = valPrice
      } else if (type == 4 && val) {
        this.itemObj.annualSales = valPrice
      } 
    },
    changeCompany(val) {
      this.companyList.forEach((item) => {
        if (item.value == val) {
          this.itemObj.companyTypeName = item.label
        }
      })
    },
    changeChannel(val) {
      this.infoChannelList.forEach((item) => {
        if (item.value == val) {
          this.itemObj.infoChannelName = item.label
        }
      })
    },
    //  视频播放
    playVideo() {
      this.video.src = this.videoList[0] || ''
      this.video.visible = true
      this.$refs.videoHook.playVideo()
    },
    // 又是一坨坨的LJ代码
    initParams() {
      // this.imgList = ['http://image.yunjiglobal.com/20191115161005353362.jpg?imageView2/1/w/300/h/300','http://image.yunjiglobal.com/20191115161005353362.jpg?imageView2/1/w/300/h/300','http://image.yunjiglobal.com/20191115161005353362.jpg?imageView2/1/w/300/h/300','http://image.yunjiglobal.com/20191115161005353362.jpg?imageView2/1/w/300/h/300','http://image.yunjiglobal.com/20191115161005353362.jpg?imageView2/1/w/300/h/300','http://image.yunjiglobal.com/20191115161005353362.jpg?imageView2/1/w/300/h/300','http://image.yunjiglobal.com/20191115161005353362.jpg?imageView2/1/w/300/h/300','http://image.yunjiglobal.com/20191115161005353362.jpg?imageView2/1/w/300/h/300','http://image.yunjiglobal.com/20191115161005353362.jpg?imageView2/1/w/300/h/300','http://image.yunjiglobal.com/20191115161005353362.jpg?imageView2/1/w/300/h/300']
      this.imgList = []
      this.itemImgList = []
      // this.videoList = ['https://image.yunjiweidian.com/Figljd-0mIutfGnnWjLIBV12gXfL']
      this.videoList = []
      this.textAreaValue = ''
      this.upLoadingImg = false
      this.upLoadingSaleImg = false
      this.upLoadingVideo = false
    },
    videoUpload(el) {
      this.fileChange(el, 'video')
    },
    salesFileChange(el) {
      this.fileChange(el, 'sale')
    },
    itemfileChange(el) {
      this.fileChange(el, 'item')
    },
    // 上传图片 又是一坨坨的LJ代码
    fileChange(el, type) {
      // type ：item代表商品品质
      // if (this.upLoadingVideo || this.upLoadingImg) return
      if (!el.target.files[0].size) {
        el.target.value = ''
        return
      }
      let duration
      if (type == 'video') {
        const url = URL.createObjectURL(el.target.files[0])
        const oVideo = document.createElement('video')
        oVideo.setAttribute('src', url)
        oVideo.oncanplay = () => {
          console.log(`视频时长：${oVideo.duration}秒`)
        }
        console.log(el.target.files[0].size)
        if (el.target.files[0].size > 50 * 1024 * 1024) {
          this.Toast('视频控制在50M以内')
          el.target.value = ''
          return
        }
      }
      
      if (type != 'video') {
        if (el.target.files[0].size > 5 * 1024 * 1024) {
          this.Toast('单张图片最大5M')
          el.target.value = ''
          return
        }
        if (this.imgList.length > this.maxImageSize || this.itemImgList.length > this.maxImageSize) {
          this.Toast(`最多只能上传${this.maxImageSize}张图片`)
          el.target.value = ''
          return
        }
      }
      if (!this.token) {
        this.AJAX.getToken({ appCont: this.appCont || 0 }).then((json) => {
          this.token = json.data.token
          this.getImgList(el, type)
        })
      } else {
        this.getImgList(el, type)
      }
      el.target.value = ''  
    },
    deleSaleByIndex(index) {
      this.salesNumImgList.splice(index, 1)
    },
    //  删除视频
    deleVideoByIndex(index) {
      this.videoList.splice(index, 1)
    },
    //  删除图片
    deleImgByIndex(index) {
      this.imgList.splice(index, 1)
    },
    deleItemByIndex(index) {
      this.itemImgList.splice(index, 1)
    },
    upPicImg(form, res) {
      const xhr = new XMLHttpRequest()
      const that = this 
      let qiniuUploadUrl
      if (window.location.protocol === 'https:') {
        qiniuUploadUrl = 'https://up.qbox.me'
      } else {
        qiniuUploadUrl = 'http://upload.qiniu.com'
      }
      xhr.open('POST', qiniuUploadUrl, true)
      xhr.onreadystatechange = function (response) {
        if (xhr.status == 200 && xhr.readyState == 4) {
          res && res(JSON.parse(xhr.responseText).key)
        } else {
          that.upLoadingImg = false
          that.upLoadingVideo = false
          that.upLoadingSaleImg = false
        }
      }
      xhr.send(form)
    },
    // 获取图片
    getImgList(el, type) {
      if (el.target.files.length) {
        let formData = null
        for (let i = 0; i < el.target.files.length; i++) { 
          const fileType = el.target.files[i].type
          if (type == 'sale') {
            this.upLoadingSaleImg = true
          } else if (fileType.indexOf('image') > -1) {
            this.upLoadingImg = true
          } else if (fileType.indexOf('video') > -1) {
            this.upLoadingVideo = true
          }
          formData = new FormData()
          formData.append('token', this.token)
          formData.append('file', el.target.files[i]) 
          this.upPicImg(formData, (res) => {
            this.upLoadingImg = false
            this.upLoadingSaleImg = false
            this.upLoadingVideo = false 
            if (fileType.indexOf('image') > -1) { //  图片
              if (type == 'item' && this.itemImgList.length < 5) {
                this.itemImgList.push(`//image.yunjiweidian.com/${res}`)
              } else if (type == 'sale' && this.salesNumImgList.length < 5) {
                this.salesNumImgList.push(`//image.yunjiweidian.com/${res}`)
              } else if (this.imgList.length < 5) {
                this.imgList.push(`//image.yunjiweidian.com/${res}`)
              }
            } else if (fileType.indexOf('video') > -1) { // 视频
              const videoUrl = `//image.yunjiweidian.com/${res}`
              this.videoList.push(videoUrl)
              this.itemObj.video = videoUrl
              this.video.src = videoUrl
            }
          })
        }
      }
    },
    getTokens() {
      this.AJAX.getToken({ appCont: this.appCont || 0 }).then((res) => {
        this.token = res.data
      }).catch((error) => {
        console.log(error)
      })
    },
    categorySelection(val) {
      this.itemList.forEach((item) => {
        if (item.value == val) {
          this.itemObj.categoryName = item.label
        }
      })
    },
    clearParam() {
      this.itemObj = {
        businessLife: '', // 营业年限
        categoryId: '', // 分类id
        categoryName: '', // 分类名称
        // checkImg: '', // 审核截图，多张以英文分号分隔
        // checkStatus: '', // 审核状态，0-待审核，1-通过，2-不通过
        companyName: '', // 公司名称
        companyType: '', // 公司类型
        companyTypeName: '', // 公司类型名称
        contactsEmail: '', // 联系人邮箱
        contactsName: '', // 联系人姓名
        contactsPhone: '', // 联系人电话
        contactsSex: 0, // 联系人性别，0-男性，1-女性
        cooperativeBrand: '', // 知名合作品牌
        itemImg: '', // 商品图片，多张以英文分号分隔
        itemName: '', // 商品名称
        qualityImg: '', // 商品品质证明，多张以英文分号分隔
        recommendReason: '', // 推荐理由
        // similarItemLink: '', // 同类同款商品链接，多条以英文分号分隔
        specPrice: '', // 建议云集售价
        supplyCommodityPrice: '', // 云集供货价
        annualSales: '', // 年销售额
        vipPrice: '', // 市场参考价,
        video: '', // 亮点介绍视频，多个以英文分号分隔,
        salesNumImg: '', // 销量证明图片，多张以英文分号分隔,
        platformLink: '', // 口碑体量证明对应平台链接，多条以英文分号分隔
        infoChannel: '', // 信息获取渠道id
        infoChannelName: '' // 信息获取渠道
      }
    },
    validParam() {
      const params = Object.assign({}, this.itemObj)
      params.itemImg = (this.imgList && this.imgList.join(',')) || ''
      params.qualityImg = (this.itemImgList && this.itemImgList.join(',')) || ''
      params.salesNumImg = (this.salesNumImgList && this.salesNumImgList.join(',')) || ''
      const domList = document.getElementsByClassName('address-input-box')
      for (const key in domList) {
        const str = domList[key].className && domList[key].className.replace(/error/, '')
        if (str) {
          domList[key].className = str
        }
      }
      const keyWord = []
      Object.keys(params).forEach((item) => {
        if (item != 'platformLink' && item != 'contactsSex' && item != 'supplyCommodityPrice') {
          if (!params[item]) {
            keyWord.push(item)
          }
        }
      })
      this.tipTxt = '您提交的信息不完整，请补充信息后提交'
      if (keyWord && keyWord.length) {
        // 这是一段业务需求的LJ代码
        // 因为Object.kyes 会自动排序问题导致只能写这个if排序校验 不考虑顺序问题 可以删除以下的if判断
        if (keyWord.some(item => item == 'categoryId')) {
          keyWord[0] = 'categoryId'
          document.documentElement.scrollTop = document.body.scrollTop = 0
        } else if (keyWord.some(item => item == 'itemName')) {
          keyWord[0] = 'itemName'
          document.documentElement.scrollTop = document.body.scrollTop = 0
        } else if (keyWord.some(item => item == 'itemImg')) {
          keyWord[0] = 'itemImg'
          document.documentElement.scrollTop = document.body.scrollTop = 0
        } else if (keyWord.some(item => item == 'video')) {
          keyWord[0] = 'video'
          document.documentElement.scrollTop = document.body.scrollTop = 0
        } else if (keyWord.some(item => item == 'vipPrice')) {
          keyWord[0] = 'vipPrice'
          document.documentElement.scrollTop = document.body.scrollTop = 0
        } else if (keyWord.some(item => item == 'specPrice')) {
          keyWord[0] = 'specPrice'
          document.documentElement.scrollTop = document.body.scrollTop = 0
        } else if (keyWord.some(item => item == 'annualSales')) {
          keyWord[0] = 'annualSales'
          document.documentElement.scrollTop = document.body.scrollTop = 0
        } else if (keyWord.some(item => item == 'recommendReason')) {
          keyWord[0] = 'recommendReason'
        } else if (keyWord.some(item => item == 'salesNumImg')) {
          keyWord[0] = 'salesNumImg'
        } else if (keyWord.some(item => item == 'qualityImg')) {
          keyWord[0] = 'qualityImg'
        } else if (keyWord.some(item => item == 'contactsName')) {
          keyWord[0] = 'contactsName'
        } else if (keyWord.some(item => item == 'contactsPhone')) {
          keyWord[0] = 'contactsPhone'
        } else if (keyWord.some(item => item == 'companyName')) {
          keyWord[0] = 'companyName'
        } else if (keyWord.some(item => item == 'businessLife')) {
          keyWord[0] = 'businessLife'
        } else if (keyWord.some(item => item == 'companyType')) {
          keyWord[0] = 'companyType'
        } else if (keyWord.some(item => item == 'cooperativeBrand')) {
          keyWord[0] = 'cooperativeBrand'
        } else if (keyWord.some(item => item == 'infoChannel')) {
          keyWord[0] = 'infoChannel'
        }
        // this.Toast(this.tipTxt)
        this.errorStatus = 'error'
        this.tipStatus = true
        const errorDom = document.getElementsByClassName(keyWord[0])
        if (errorDom) {
          errorDom[0].scrollIntoView({ behavior: 'auto' })
          errorDom[0].className += ' error'
        }
        return 
      }
      if (this.saveLoading) {
        return 
      }
      this.saveLoading = true
      this.handleSave(params)
    },
    handleSave(params) {
      const that = this
      let request = this.AJAX.insertHotPut
      if (sessionStorage.getItem('test')) {
        request = this.AJAX.insertHotPutGet
      }
      request(params).then((res) => {
        if (res.errorCode === 0 || res.code === 0) {
          // this.Toast('恭喜,爆款商品信息提交成功!稍候2秒将返回首页')
          this.errorStatus = 'submit'
          this.tipStatus = true
          this.clearParam()
        } else {
          this.Toast(res.errorMessage)
        }
        this.saveLoading = false
      }, () => {
        this.saveLoading = false
      }).catch(() => {
        this.saveLoading = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.tip-dialog{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  color: #333;
  font-size: .32rem;
  background-color:rgba(0, 0, 0, .7);
  .dialog-txt{
    position: fixed;
    left: 50%;
    top: 50%;
    width: 6rem;
    margin:-1.6rem 0 0 -3rem;
    height: 3.2rem;
    border-radius: .3rem;
    background-color: #fff;
    text-align: center
  }
  .tip-txt{
    display: flex;
    flex: 1;
    line-height: 1.5;
    justify-content: center;
    align-items: center;
    height: 2.16rem;
  }
  .handle-box{
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #f6f6f6;
    height: 1.04rem;
    color:#F10D3B
  }
}
.item-message{min-height:100vh;padding-bottom:.5rem;background-color: #f2f2f2;}
.add-edit-address-ul{
  margin-top:.3rem;
  background: #fff;
  li{
    .address-input-box{
      line-height: 1rem;        
      color: #333;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;  
      font-size: 0.26rem;   
      .address-detail{
        padding-top:0.32rem;   
        padding-right: 0.3rem;
        font-size: 0.26rem;
        font-weight: 300     
      }  
      .icon-jiantou{color:#bbb;margin-left: 0.15rem;font-size: 0.24rem;font-weight: bold}
    }
    .address-box-detail{
      overflow: auto;
      padding-bottom: 0.4rem;
    }
    .address-change-titie {
      color: #F10D3B;
      font-size: .24rem;      
      line-height: 0.6rem;       
      margin-top: -0.25rem;
    }
    .title{
      width: 2.0rem;
      font-family: 'PingFangSC-Regular';       
      color: #333; 
      font-size: .26rem;
      font-weight: 400;    
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 2.0rem;  
      .sub-title{
        color: #999
      }   
    }
    .select{
      font-family: 'PingFangSC-Regular';    
      font-size: .26rem;
    }
    .textarea{
      font-family: 'PingFangSC-Regular';    
      font-size: .26rem;
      border-radius: .12rem;
    }
    .fr{
      display: flex;
      width: calc(100% - 1.5rem);
      padding-right: .2rem;
      font-family: 'PingFangSC-Regular';       
      font-size: .26rem;
      span{
        display: inline-block;
        white-space: nowrap
      }
      .icon-jiantou{
        font-size: 0.24rem;    
        font-weight: bold       
      }
    }
  }
}
.border-top-1px,.border-bottom-1px,.border-right-1px,.border-top-new-1px,.border-left-1px{position: relative;border-bottom: 1px solid #e0e0e0;}
// .border-bottom-1px:before{content: ' ';display: block;position: absolute;left: 0;bottom: 0;width: 100%;border-top: 1px solid #e0e0e0;}
.add-edit-address-ul > li{padding: 0 0 0 .3rem;background-color: #fff;width: 100%;box-sizing: border-box;}
.add-edit-address-ul input::-webkit-input-placeholder,.add-edit-address-ul textarea::-webkit-input-placeholder,.placeholder {font-size: 0.26rem;font-weight: 330;color: #aaa;}  
.add-edit-address-ul input,.add-edit-address-ul textarea{width: 100%;height: 1rem;box-sizing: border-box;resize: none;-webkit-tap-highlight-color:rgba(0,0,0,0);word-break: break-all;}
.add-edit-address-ul textarea{padding: .1rem 0;-webkit-user-select: text;}
.mark-lab{
  padding: 0 0 0 .3rem;
  background: #fff;
  margin-bottom: 0.2rem;
  &:last-child.border-bottom-1px.gray-light:before{
    content: "";
    border-top: 0 solid #fff;
  }
  .blod{
    font-weight: 400 
  }
  .lab-tip{    
    display: flex;
    justify-content: space-between;         
    .fr{
      float: right;
      .iconfont{
        margin-left: 0.16rem;
        font-size: 0.24rem;
        font-weight: bold;
        color: #bbb
      }
      .wb{color: #333;}
      .text{color: #aaa}
    }
  }
} 
.color-3{color:#333 !important}
.next-btn{
  display: flex;
  flex: 1;
  justify-content: center;
  align-item: center;
  flex-basis: 5.6rem;
  width:5.6rem; 
  height: .96rem; 
  line-height: .96rem; 
  margin:.5rem auto 0;
  color: #fff;
  font-size: .32rem;
  margin-top: .5rem;
  background-color: #EE2532;
  border-radius: .56rem
}
.add-edit-address-ul li .block{
  display:block !important;
  padding-top: .4rem;
  line-height: 1;
  .title{width: 100% !important}
  .textarea{
    margin-top: .2rem;
    height: 2.56rem;
    padding:.2rem .4rem .2rem;
    background-color: #FAFAFA;
  }
  .h-68{
    height: 1.36rem;
  }
}
.add-edit-address-ul li .select{
  width: 100%;
  height: 1rem;
  margin-top: -.04rem
}
.add-edit-address-ul li .l-h-1{
  line-height: 1;
  margin-top: 0
}
.w-68{
  width: 1.36rem;
  position: relative;
  z-index: 2;
  .select{
    color:#999;
    z-index: 2;
  }
  .b-arrow{
    position:absolute; 
    right: .1rem; 
    top: 50%;
    margin-top: -.05rem;
    z-index: 1;    pointer-events: none;
  }
}
.b-arrow{width: .18rem; height: .09rem;    pointer-events: none; margin-right: .2rem}
.m-10{
  margin: .1rem 0
}
.color-grey{color:#aaa !important}
.w-64{position:relative;display:inline-block;width: 1.28rem; height: 1.28rem; border-radius: .08rem; margin: .08rem .2rem .08rem 0;}
.w-64 img{
  width: 100%;height:100%;
  border-radius: .08rem;
}
.w-64 .video{
  width: 100%;
  height: 100%;
}

.w-64 .file{
  position: absolute;
  left: 0; 
  top: 0;
  width: 1.28rem;
  height: 1.28rem;
  color: transparent;
  background: transparent;
  opacity: 0;
}
.w-64 .play-btn{
  position: absolute;
  width:.6rem;
  height: .6rem;
  left: 50%;
  top: 50%;
  margin-left: -.3rem;
  margin-top: -.3rem;
}
.handle-btn{
  position:absolute;
  right:0;
  top: 0;
  width: .48rem;
  padding: .05rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: .28rem;
  border-radius: 0 .08rem 0 0;
  background-color: rgba(0, 0, 0, .4);
}
.w-64 .loading{
  position: absolute;
  width:.6rem;
  height: .6rem;
  left: 50%;
  top: 50%;
  margin-left: -.3rem;
  margin-top: -.3rem;
  animation: florFote 1s linear infinite;
}
.save-loading{
  position: fixed;
  left: 0; 
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, .8);
  z-index: 110;
}
.add-edit-address-ul li .categoryId, .add-edit-address-ul li .itemName,
.add-edit-address-ul li .businessLife,.add-edit-address-ul li .companyType,
.add-edit-address-ul li .contactsEmail,.add-edit-address-ul li .contactsPhone,
.add-edit-address-ul li .cooperativeBrand,.add-edit-address-ul li .itemImg,
.add-edit-address-ul li .qualityImg,.add-edit-address-ul li .recommendReason,
.add-edit-address-ul li .specPrice,.add-edit-address-ul li .supplyCommodityPrice,
.add-edit-address-ul li .vipPrice,.add-edit-address-ul li .video,
.add-edit-address-ul li .salesNumImg,
.add-edit-address-ul li .platformLink,
.add-edit-address-ul li .annualSales{
  // border-color:red !important;
  // color: red;
  // *{
  //   color: red
  // }
}
.add-edit-address-ul li .error{
  border-color:red !important;
  color: red;
  .title{
    color: red
  }
}
.p-r-2{padding-right: .2rem}
.m-r-4{margin-right: .3rem;margin-bottom:.3rem;}
.relative{
  position: relative;
  display:flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  .absolute-txt{
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
  }
}
@keyframes florFote {
  0%{
    transform: rotateZ(0deg);
  }
  
  100%{
    transform: rotateZ(360deg);
  }
}
</style>
